import { ICollection } from '@common/interfaces/collection.interface';
import { createCollection } from '@common/utils/create-collection.util';
import { ISubscriptionDto } from '@src/api/model/subscription.dto';

export const filterSubscriptions = (subs: ICollection<ISubscriptionDto> | undefined): ICollection<ISubscriptionDto> => {
    const [canceledSub] = (subs?.list || [])
        .filter((s) => s.status === 'cancelled' && !s.deleted)
        .sort((a, b) => (b.cancelled_at || 0) - (a.cancelled_at || 0));
    const activeSubs = subs?.list.filter((s) => s.status !== 'cancelled' && !s.deleted);
    return createCollection(
        activeSubs?.length
            ? subs?.list.filter((s) => s.status !== 'cancelled' && !s.deleted)
            : canceledSub
            ? [canceledSub]
            : [],
        subs?.next_page,
        subs?.request,
    );
};
